import React, { useEffect, useState } from "react";
import { Col, FormGroup, Form, Label } from "reactstrap";
import { useGetLocalizationLabel } from "../useAPIMethods";
import { IconButton } from "@mui/material";
import { BsQuestionCircleFill, BsFillXOctagonFill } from "react-icons/bs";
import EditNodeDetails from "./EditNodeDetails";
import { useDownloadCSRCertificate, useAddSecureConnectNetworkPort, useFetchHubParamsData } from "../useAPIMethods";
import { GetExternalHubURILink } from 'action/secureconnectAction';
import { useDispatch, useSelector } from "react-redux";
import { NoMaxWidthTooltip, HeaderTitle, FooterButtons, EditActions, ErrorModal, CloseButton, GenCSRButton, NextButton, SpinnerContainer } from "../styled";
import {Icon} from 'semantic-ui-react';
import APIutil from "api/APIutils";
import * as url from "api/url";
import { MdClose } from "react-icons/md";
import { Button } from "@material-ui/core";
import Spinner from "components/common/LegacySpinner";

const AddNode = ({ history, networkList, OnCancel, getNetworkList }) => {
    const { getLabel } = useGetLocalizationLabel();
    const dispatch = useDispatch();
    const externalHubUri = useSelector(state => state.HubManagementRootReducer.GetExternalHubUri);
    const { error, errorMessage, downloadCSRCertificate } = useDownloadCSRCertificate(history);
    const { data } = useFetchHubParamsData();
    let linkNode;
    const [state, setState] = useState({
        isError: false,
        errorMessage: "",
        enteredNetworkName: "",
        errorOnNext: false,
        isNextClicked: false,
        SelectedLinkNode: "2",
        validateButton:true,
        portErrorMessage: "",
        enteredNetworkPort: "",
        hubEndpoint: ""
    });
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showHubValidationModal, setShowHubValidationModal] = useState(false);
    const [selectedMode, setselectedMode] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        dispatch(GetExternalHubURILink());
    },[]);

    useEffect(() => {
        if(externalHubUri.length && externalHubUri !== null && externalHubUri !== undefined && state.SelectedLinkNode !== "0"){
           let hubEndpoint =  externalHubUri+'/'+state.enteredNetworkName;
           setState(prevState => ({
                ...prevState,
                hubEndpoint: hubEndpoint
           }))
        }
    }, [externalHubUri, state.enteredNetworkPort, state.enteredNetworkName, state.SelectedLinkNode])

    var linkNodeOptions = getLabel("CreateNode").split(',');
    linkNode = linkNodeOptions.map(el => (
        <option id={el} value={el}>{getLabel("CreateNode." + el)}</option>
    ));

    const IsHubNetworkExists = (lMode) => {
        let isHubExists = false;
        if (Array.isArray(networkList) && networkList.length && lMode !== -1) {
            const lstNetworks = JSON.parse(JSON.stringify(networkList));
            for (let i = 0; i < lstNetworks.length; i++) {
                if (lstNetworks[i] && lstNetworks[i].mode === lMode) {
                    isHubExists = true;
                    break;
                }
            }
        }
        return isHubExists;
    }

    const formData ={ 
        "NetworkID": 0,
        "NetworkName": state.enteredNetworkName,
        "EndPointUrl": state.hubEndpoint,
        "IsNodeConnected": false,
        "NetworkNumber":0,
        "Mode": 2,
        "HubPort": data.portNumber,
        "UUID": "",
        "VMAC": "",
        "PrimaryHubURL":  state.hubEndpoint.substring(0, state.hubEndpoint.lastIndexOf('/')).replace(state.hubEndpoint.split(":")[1],"//localhost"),
        "FailOverHubURL": "",
        "TlsVersion": data.tlsVersion !== undefined && data.tlsVersion !== null && IsHubNetworkExists(2) ? data.tlsVersion.split(',') : ["Tls12", "Tls13"],
        "ConnectionTimeOut": 10,
        "RootCertificateSubjectName": "",
        "RootCertificateValidity": 0,
        "OperationalCertificateSubjectName": "",
        "OperationalCertificateValidity": 0,
        "IsEnabled": true,
    };  

    const validateName = (name) => {
        let isDuplicateName = false;
        if (name && Array.isArray(networkList) && networkList.length) {
            const lstNetworks = JSON.parse(JSON.stringify(networkList));
            for (let i = 0; i < lstNetworks.length; i++) {
                if (lstNetworks[i] && lstNetworks[i].networkName && lstNetworks[i].networkName.toLowerCase() === name.toLowerCase()) {
                    isDuplicateName = true;
                    break;
                }
            }
        }
        if (isDuplicateName) {
            return {
                errorMessage: getLabel("DublicateName") ? getLabel("DublicateName") : "Name already exist",
                isError: true
            };
        } else if (!name) {
            return {
                errorMessage: getLabel("EntryRequired") ? getLabel("EntryRequired") : "An entry is required",
                isError: true
            };
        } else {
            return {
                errorMessage: "",
                isError: false
            };
        }
    }

    const onChangeName = (name) => {
        const regex = new RegExp(/^[A-Za-z][a-zA-Z0-9-]*$/);
        const regexAlp = new RegExp(/[A-Za-z]/i); // To validate name should start with an alphabet

        if (name && (!regex.test(name) || !regexAlp.test(name))) {
            setState(prevState => ({
                ...prevState,
                errorMessage: !regexAlp.test(name) ?
                    "Network name should start with an alphabet, it can contain alphanumeric characters or Hyphen(-)" : "Network name should not contain any special characters or space except Hyphen(-)",
                isError: true,
            }));
        } else {
            const errorValidation = validateName(name);
            setState(prevState => ({ ...prevState, ...errorValidation, enteredNetworkName: name, errorOnNext: false }));
        }
    }

    const validateinputFields = () =>{
        setselectedMode('GenerateCSR');
        let IsHubExists = ValidateHub();
        if(IsHubExists){
            onToggleHubValidationModal();
        }else{
            downloadCSRAfterHubValidation();
        }
    }

    const downloadCSRAfterHubValidation = () => {
        downloadCSRCertificate("NewRequest.csr");
        setState(prevState => ({ ...prevState,validateButton:false}));
    }

    const createNodeNext = () => {
        if (state.isError) {
            setState(prevState => ({ ...prevState, errorOnNext: true, isNextClicked: false }));
        }
        else {
            const { enteredNetworkName } = state;
            const errorDetails = {...validateName(enteredNetworkName)}
            if (errorDetails && (errorDetails.isError)) {
                setState(prevState => ({ ...prevState, ...errorDetails, errorOnNext: true, isNextClicked: false }));
            }
            else {
                setState(prevState => ({ ...prevState, errorOnNext: false, isNextClicked: true }));
            }
        }
    }

    const SaveCADetails =  async(data, callBackFunction) => {
        setLoading(true);
        try {
          const response = await APIutil.postData(url.post_secure_network_link, data);
          if (response && response.status === 200) {
            useAddSecureConnectNetworkPort(response.data.networkID, false);
            callBackFunction && callBackFunction("success");
          } else {
            const message =
              response && response.statusText
                ? response.statusText
                : "Something went wrong. Please try refreshing the page.";
            callBackFunction && callBackFunction("error", { message });
          }
        } catch (error) {
          callBackFunction && callBackFunction("error", error);
          throw error;
        }
    }

    const createCALink = () => {
        setselectedMode('GenerateCALink');
        let IsHubExists = ValidateHub();
        if(IsHubExists){
            onToggleHubValidationModal();
        }else{
            createCALinkAfterHubValidation();
        }
    }

    const createCALinkAfterHubValidation = () => {
        if(state.isError){
            setState(prevState => ({...prevState}))
        }else{
            const {enteredNetworkName} = state;
            const errorDetails = {...validateName(enteredNetworkName)};
            if(errorDetails && (errorDetails.isError)){
                setState(prevState => ({...prevState, ...errorDetails}))
            }
            else{
                SaveCADetails(formData, (status, error) => {
                    if (status === "success") {
                        setLoading(false);
                        getNetworkList();
                        OnCancel();
                    } else {
                        setLoading(false);
                        console.error("Error saving data:", error);
                        setShowErrorModal(true);
                    }
                });
            }
        }
    }

    const onCancelErrorModal = () => {
        setShowErrorModal(!showErrorModal);
    }

    const onSaveErrorModal = () =>{
        return <>
            <HeaderTitle id="header-title">
                <div onClick={onCancelErrorModal}><MdClose /></div>
                <label><BsFillXOctagonFill /><span>{getLabel("ImportCertificateErrorMessage") ? getLabel("ImportCertificateErrorMessage") : "Something went wrong. Please Try Again..."}</span></label>
            </HeaderTitle>
            <FooterButtons id="model-footer-section">
                <EditActions >
                    <Button style={{margin : "25px 0 0 190px"}} id="cancel_button" variant="contained" onClick={onCancelErrorModal}>{getLabel("OK") ? getLabel("OK") : "OK"}</Button>
                </EditActions>
            </FooterButtons>
        </>
    }

    const onHubValidationModal = () => {
        return <>
            <HeaderTitle id="hub-header-title" className="HubValidation-lbl">
                {
                    state.SelectedLinkNode === "2" ? <span><b>Warning:</b>&nbsp;&nbsp;Selecting this Mode will change all existing BACnet/SC Hub Links to Node+Hub+CA Mode.  Tracer Ensemble Hub Links must all be configured the same.  Proceeding to change to all Hub Links to Node+Hub+CA Mode may break existing BACnet/SC connections.</span> 
                    : <span><b>Warning:</b>&nbsp;&nbsp;Selecting this Mode will change all existing BACnet/SC Hub Links to Node+Hub Mode.  Tracer Ensemble Hub Links must all be configured the same.  Proceeding to change to all Hub Links to Node+Hub Mode may break existing BACnet/SC connections.</span>
                }
            </HeaderTitle>
            <FooterButtons id="hub-model-footer-section">
                <EditActions >
                    <Button style={{margin : "25px 0 0 150px", "color":"white"}} id="hub_cancel_button" variant="contained" onClick={onCancelHubValidation}>{getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}</Button>
                    <Button style={{margin : "25px 0 0 15px", "background-color": "#2070cf", "color":"white"}} id="hub_ok_button" variant="contained" onClick={onContinueSave}>{getLabel("OK") ? getLabel("OK") : "OK"}</Button>
                </EditActions>
            </FooterButtons>
        </>
    }

    const onToggleHubValidationModal = () => {
        setShowHubValidationModal(!showHubValidationModal);
    }

    const ValidateHub = () => {
        let lMode = state.SelectedLinkNode === "2" ? 1 : state.SelectedLinkNode === "1" ? 2 : -1;
        return IsHubNetworkExists(lMode);
    }

    const onContinueSave = () => {
        if (selectedMode === 'GenerateCSR') {
            downloadCSRAfterHubValidation();
        }else {
            createCALinkAfterHubValidation();
        }
        onToggleHubValidationModal();
    }

    const onCancelHubValidation = () => {
        onToggleHubValidationModal();
        OnCancel();
    }

    return (
        <div className="createnode_container">
            {
                state.isNextClicked ? <EditNodeDetails NodeType={state.SelectedLinkNode} Name={state.enteredNetworkName} OnCancel={OnCancel} getNetworkList={getNetworkList} EndPoint={state.hubEndpoint}/> :
                    <Form>
                        <FormGroup row style={{ "margin-bottom": "1px" }}>
                            <Col className="header" sm={{ size: 4 }}>
                                <Label id="create-label" className='workordermainheaderlbl' style={{ marginbottom: "30px" }}>{getLabel("Create.HeaderTitle") ? getLabel("Create.HeaderTitle") : "Create New BACnet Secure Connect Link"}</Label>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={{ size: 3 }}>
                                <Label id="linkmode-label" style={{ float: 'left', fontWeight: "bold" }} className="custom_label">{getLabel("Create.LinkMode") ? getLabel("Create.LinkMode") : "Link Mode"}</Label>
                            </Col>
                            <Col sm={{ size: 7 }}>
                                <NoMaxWidthTooltip arrow placement="right" title="Select a mode based on the function of the device on the BACnet/SC network." font-size={14}>
                                    <IconButton id="linkmode-help" style={{ margin: '-3px 5px 1px 30px', backgroundColor: 'white', color: "black", fontSize: "larger" }}>
                                        <BsQuestionCircleFill />
                                    </IconButton>
                                </NoMaxWidthTooltip>
                                <select id="linkmode-dd" className="customlink_dropdown" style={{ width: '180px', padding: '5px', margin: '-10px 4px 5px 1px', borderRadius: '2px' }} value={state.SelectedLinkNode} name="Link Node" onChange={(e) => setState(prevState => ({...prevState, SelectedLinkNode :e.target.value})) }>
                                    {linkNode}
                                </select>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={{ size: 3 }}>
                                <Label id="name-label" className="custom_label" style={{ fontWeight: "bold" }}>
                                    {getLabel("Create.Name") ? getLabel("Create.Name") : "Name*"}
                                </Label>
                            </Col>
                            <Col sm={{ size: 8 }} style={{"margin-bottom": state.isError ? '10px' : '15px'}}>
                                <input
                                    type="text"
                                    maxLength="200"
                                    id="network-name"
                                    className={state.isError ? "errorhighlight pm_textbox" : "pm_textbox"}
                                    defaultValue={state.enteredNetworkName}
                                    style={{ margin: '2px 2px 2px 65px', borderRadius: '2px', padding: '5px', width: '250px' }}
                                    onChange={(event) => onChangeName(event.target.value)}
                                />
                                <span hidden={!state.isError} id="name-error">
                                    <Icon name='exclamation triangle' style={{color:'#D42D27', width: '22px', height: '22px'}} /><br />
                                    <b style={{ 'color': '#D42D27', fontStyle: 'italic', fontSize: '10px', fontFamily: 'Lato', marginLeft: '64px' }}>{state.errorMessage}</b>
                                </span>
                            </Col>
                        </FormGroup>
                        {
                            (state.SelectedLinkNode !== "0") ?
                            <FormGroup row>
                                <Col sm={{ size: 3 }}>
                                    <Label id="endpoint-label" style={{ float: 'left', fontWeight: "bold" }} className="custom_label">
                                        {getLabel("Create.Endpoint") ? getLabel("Create.Endpoint") : "Endpoint"}
                                    </Label>
                                </Col>
                                <Col sm={{ size: 7}}>
                                    <NoMaxWidthTooltip arrow placement="right" title="Hub URL help goes here..." font-size={14}>
                                        <IconButton id="endpoint-help" style={{ margin: '-3px 5px 1px 30px', backgroundColor: 'white', color: "black", fontSize: "larger" }}>
                                            <BsQuestionCircleFill />
                                        </IconButton>
                                    </NoMaxWidthTooltip>
                                    <Label id="endpoint-url" style={{ fontFamily: "Verdana" }}>{state.hubEndpoint}</Label>
                                </Col>
                            </FormGroup> : <></>
                        }
                        { 
                            (state.SelectedLinkNode === "2") ?
                            <FormGroup row>
                                <Col sm={{ size:3 }}>
                                    <Label id="generatecsr-label" className="custom_label" style={{ fontWeight: "bold" }}>{getLabel("Create.GenerateCALinkTitle") ? getLabel("Create.GenerateCALinkTitle") : "To begin, Create Link as CA"}</Label><br />
                                </Col>
                                <Col sm={{ size:8 }}>
                                    <GenCSRButton id="generatecsr-button" variant="contained" style={{ margin: '-5px 12px -14px 66px' }} onClick={createCALink}>{getLabel("Create.GenerateLinkAsCA") ? getLabel("Create.GenerateLinkAsCA") : "Create Link as CA"}</GenCSRButton>
                                </Col>
                            </FormGroup> : 
                            <FormGroup row>
                                <Col sm={{ size: 3 }}>
                                    <Label id="generatecsr-label" className="custom_label" style={{ fontWeight: "bold" }}>{getLabel("Create.GenerateCSRTitle") ? getLabel("Create.GenerateCSRTitle") : "To begin, generate a CSR"}</Label><br />
                                </Col>
                                <Col sm={{ size: 8 }}>
                                    <GenCSRButton id="generatecsr-button" variant="contained" style={{ margin: '-5px 12px -14px 66px' }} onClick={validateinputFields} >{getLabel("Create.GenerateNewCSR") ? getLabel("Create.GenerateNewCSR") : "Generate New CSR"}</GenCSRButton>
                                    <span hidden={!error} id="error-text">
                                        <Icon name='exclamation triangle' style={{color:'#D42D27', width: '22px', height: '28px'}} /><br />
                                        <b style={{ 'color': '#D42D27', fontStyle: 'italic', fontSize: '10px', fontFamily: 'Lato', marginLeft: '64px' }}>{errorMessage}</b>
                                    </span>
                                </Col>
                            </FormGroup>
                        }   
                        <FormGroup row style={{ "padding-left": "12px" }}>
                            <CloseButton id="cancel-button" variant="contained" onClick={OnCancel} >{getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}</CloseButton>
                            { state.SelectedLinkNode !== "2" ? 
                                <NextButton id="next-button" primary className="btn-black" onClick={createNodeNext} disabled={state.validateButton}>
                                    {getLabel("Next") ? getLabel("Next") : "Next >"}
                                </NextButton> : <></> }
                        </FormGroup>
                    </Form>
            }
            {
                showErrorModal && (<ErrorModal
                    isOpen={!state.isModelOpen}
                    >
                     {onSaveErrorModal()} 
                    </ErrorModal>)
            }
            {
                    showHubValidationModal && (
                        <ErrorModal
                    isOpen={!state.showHubValidationModal}
                    >
                     {onHubValidationModal()} 
                    </ErrorModal>
                    )
            }
            {  loading ? <SpinnerContainer>
                                <Spinner />
                           </SpinnerContainer> 
                        : null
            }
        </div>
    );
};

export default AddNode;